// Stonehill-style top-nav menu structure for Naavi.
// label = top item, href = route, items = dropdown links (column).

export const HEADER_MENUS = [
  {
    label: "About",
    href: "/about",
    items: [
      { label: "The Naavi Story", href: "/about#story", desc: "Our origin and what we stand for" },
      { label: "Our Vision and Mission", href: "/about#vision", desc: "What we aim for, every day" },
      { label: "Our Team", href: "/about#team", desc: "The people behind Naavi" },
      { label: "Board of Trustees", href: "/about#board", desc: "Stewards of our vision" },
    ],
  },
  {
    label: "Why Naavi",
    href: "/why-naavi",
    items: [
      { label: "The Differentiator", href: "/why-naavi#differentiator" },
      { label: "Core Values & Competencies", href: "/why-naavi#core" },
      { label: "Our Learning Environment", href: "/why-naavi#environment" },
      { label: "Our Facilitators", href: "/why-naavi#facilitators" },
    ],
  },
  {
    label: "Curriculum",
    href: "/curriculum",
    items: [
      { label: "Cambridge Early Years", href: "/curriculum#cambridge" },
      { label: "Six Learning Pillars", href: "/curriculum#pillars" },
      { label: "Experiential Learning Approach", href: "/curriculum#experiential" },
    ],
  },
  {
    label: "Programmes",
    href: "/programs",
    items: [
      { label: "Toddler Programme", href: "/programs#toddlers", desc: "2 – 3 yrs · Sensory play" },
      { label: "Early Years 1", href: "/programs#nursery", desc: "3 – 4 yrs · Curiosity unfolds" },
      { label: "Early Years 2", href: "/programs#pre-k", desc: "4 – 5 yrs · Confident thinkers" },
      { label: "Early Years 3", href: "/programs#kindergarten", desc: "5 – 6 yrs · School-ready" },
    ],
  },
  {
    label: "Admissions",
    href: "/admissions",
    items: [
      { label: "Admissions Process", href: "/admissions#process" },
      { label: "Apply / Enquire", href: "/admissions#enquiry" },
      { label: "Schedule a Visit", href: "/admissions#visit" },
      { label: "Fees & FAQs", href: "/faqs" },
    ],
  },
];

// Programs (Naavi-style names sourced from naaviearlyyears.edu.in)
export const NAAVI_PROGRAMS = [
  {
    id: "toddlers",
    name: "Toddler Programme",
    age: "2 – 3 yrs",
    tagline: "First steps into wonder",
    blurb:
      "A gentle, sensory-rich introduction to school life. Tiny bodies, big feelings — held in routines, songs and sand-tray play.",
    accent: "lime",
    image: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/1ch10v45_20251104_111250.jpg",
  },
  {
    id: "nursery",
    name: "Early Years 1",
    age: "3 – 4 yrs",
    tagline: "Curiosity unfolds",
    blurb:
      "Stories, songs and small-world play meet emerging literacy and number sense. Friendships begin and language blooms.",
    accent: "cornflower",
    image: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/ng9fytx1_PXL_20250626_052159977.MP.jpg",
  },
  {
    id: "pre-k",
    name: "Early Years 2",
    age: "4 – 5 yrs",
    tagline: "Confident thinkers, joyful doers",
    blurb:
      "Project work, big questions and the Cambridge Early Years framework take centre stage. Children lead, teachers listen.",
    accent: "teal",
    image: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/qpswuyme_IMG-20260313-WA0040.jpg",
  },
  {
    id: "kindergarten",
    name: "Early Years 3",
    age: "5 – 6 yrs",
    tagline: "Ready for the world",
    blurb:
      "A confident, school-ready year. Reading, writing and reasoning blend with art, drama and the courage to lead.",
    accent: "turquoise",
    image: "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/65lknuu8_IMG-20260313-WA0045.jpg",
  },
];

export const NAAVI_FAQS = [
  { q: "What age groups does Naavi Early Years cater to?", a: "We welcome children between 2 and 6 years across our Toddler, Early Years 1, Early Years 2 and Early Years 3 programmes — each carefully designed for age-specific developmental milestones." },
  { q: "Is Naavi a Cambridge-accredited preschool?", a: "Yes. Naavi is a registered Cambridge Early Years Centre, delivering the internationally recognised Cambridge Early Years curriculum alongside our research-led pedagogy." },
  { q: "What are the school timings?", a: "Naavi operates Monday to Friday from 8:30 AM to 3:30 PM. Half-day and full-day options are available across most programmes." },
  { q: "How is safety ensured on campus?", a: "Round-the-clock CCTV surveillance, biometric entry, child-safe furniture, daily hygiene checks and trained female caregivers across all areas of the school." },
  { q: "Do you offer trial visits or campus tours?", a: "Absolutely. Parents are warmly invited to schedule a guided tour — please use the enquiry form or call us to book a convenient time slot." },
  { q: "What is the teacher-to-child ratio?", a: "We maintain a healthy 1:6 ratio in the Toddler programme and 1:10 across Early Years 1, 2 and 3, ensuring every child receives individual attention." },
];

export const NAAVI_PARENTS = [
  { name: "Priya Sharma", role: "Mother of Aanya, Early Years 2", quote: "Naavi has been a second home for our daughter. The warmth and attention each child receives is simply unmatched. We see her flourishing every single day." },
  { name: "Rohan Iyer", role: "Father of Vihaan, Early Years 1", quote: "The Cambridge curriculum at Naavi is brilliantly delivered. Our son's curiosity, vocabulary and confidence have grown remarkably within just six months." },
  { name: "Meghana Rao", role: "Mother of Ira, Toddler Programme", quote: "From the cheerful classrooms to the dedicated teachers — everything at Naavi feels intentional. It's a place where children are truly seen and heard." },
  { name: "Karan Mehta", role: "Father of Aarav, Early Years 3", quote: "We toured many preschools in Whitefield. The moment we entered Naavi we knew this was where our child would feel safe, loved and challenged." },
  { name: "Sneha Kulkarni", role: "Mother of Viraj, Early Years 1", quote: "The daily updates, transparent communication and the genuine care from the team is something we deeply value as working parents." },
  { name: "Arjun Nair", role: "Father of Anika, Early Years 2", quote: "Naavi has set the foundation right. The international exposure paired with Indian-rooted values is exactly what we wanted for our little one." },
];

export const NAAVI_GALLERY = [
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/65lknuu8_IMG-20260313-WA0045.jpg",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/rvlepfl7_IMG_ACC7EFD12CF0-1.JPEG",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/glzg6uim_4a543f9c-59db-4fae-a372-b890fb29a474.JPEG",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/nns1ozg6_IMG-20251203-WA0006.JPEG",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/cx3elw29_PXL_20251015_044839924.JPEG",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/haclsa1h_IMG-20250807-WA0017.jpg",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/ynga1obl_e7540d4d-da86-46b6-937c-dea2aa6e2e43.jpg",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/qpswuyme_IMG-20260313-WA0040.jpg",
  "https://customer-assets.emergentagent.com/job_naavi-preschool/artifacts/1ch10v45_20251104_111250.jpg",
];

export const NAAVI_DIFFERENTIATORS = [
  { title: "Cambridge Early Years Centre", desc: "An internationally recognised, research-based curriculum tailored to nurture every child's unique journey.", color: "#648DE5" },
  { title: "Play & Inquiry-Based Learning", desc: "Children learn best by doing. Our environment encourages exploration, questions and self-discovery every day.", color: "#C6D947" },
  { title: "Holistic Child Development", desc: "From cognitive skills to emotional intelligence — every dimension of growth is intentionally cultivated.", color: "#5BC4B8" },
  { title: "Trained & Caring Facilitators", desc: "A passionate team of educators trained in early childhood pedagogy, gentle parenting and child psychology.", color: "#3AB0D6" },
  { title: "Sensory-Rich Environment", desc: "Naturally lit classrooms, open green play areas and Montessori-inspired materials curated for tiny hands.", color: "#648DE5" },
  { title: "Safe & Secure Campus", desc: "24/7 CCTV, child-friendly furniture, hygiene-first protocols and trained staff for complete peace of mind.", color: "#C6D947" },
];

export const NAAVI_NEWS = [
  { date: "March 2026", tag: "Open House", title: "Spring Open House for Admissions 2026 — 27", body: "Walk our gardens, meet our team and watch a real morning at Naavi unfold. Saturdays in March, by appointment.", image: "https://www.naaviearlyyears.edu.in/wp-content/uploads/2025/07/IMG_1438.jpg" },
  { date: "February 2026", tag: "Letters from Naavi", title: "What we mean when we say 'play is our pedagogy'", body: "A long-form letter from our pedagogy lead on why play, when planned with intention, is the most rigorous learning a young child can have.", image: "https://www.naaviearlyyears.edu.in/wp-content/uploads/2025/07/IMG_1113.jpg" },
  { date: "January 2026", tag: "Community", title: "Naavi welcomes its 200th family", body: "A milestone moment — and a reminder that every family who joins us shapes who we are next.", image: "https://www.naaviearlyyears.edu.in/wp-content/uploads/2025/07/PXL_20250620_041458158.MP_-1.jpg" },
  { date: "December 2025", tag: "Cambridge", title: "Recognised again as a Cambridge Early Years Centre", body: "Our renewed affiliation marks another year of bringing internationally benchmarked early years to Whitefield.", image: "https://www.naaviearlyyears.edu.in/wp-content/uploads/2025/07/IMG_8537.jpg" },
];

export const NAAVI_ADDRESS = {
  line: "No. 99, Inner Circle, Dodsworth Layout",
  city: "Whitefield, Bangalore — 560066",
  hours: "Mon — Fri · 8:30 AM — 3:30 PM",
  phone: "+91 97405 31855",
  email: "info@naaviearlyyears.edu.in",
};
